export default {"src":"/_next/static/media/private-cloud.4a5bc72f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};